import { useMutation, useQuery } from "react-query";
import { EXTERNAL_PROVIDE, EXTERNAL_PROVIDE_TOKEN } from "../config/cacheKey";
import MainLayout from "../layouts/MainLayout ";
import { getJwtToken, setJwtToken } from "../services/auth.service";
import UnAuthoized from "./unAuthorized/unAuthoized";
import { ExternalAccountLogin } from "../services/externalAccount.service";
import { ICheckOtpResponse } from "../models/account.model";
import { useEffect } from "react";
import PWASplash from "../layouts/_core/pwaSplash";
import { ApiResultModel } from "../models/common.model";
import { useNavigate } from "react-router-dom";
import Container from '@mui/material/Container';
import { isTokenExpiredOrMissing } from "../utility/tokenUtils";
import { useExternalLogin } from "../hooks/useExternalLogin";
import { useQueryClient } from "react-query";

export default function RouteWithState() {
    //external token
    //https://app.stage.samiinco.ir/externalLogin?provider=Sepino&token=minaabareghi
    //https://localhost:3030/externalLogin?provider=Sepino&token=minaabareghi
    const url = window.location.href;
    const navigate = useNavigate();
    const queryClient = useQueryClient();

    //route from kaman
    const { mutate: ExternalRouteMutate, isLoading } = useMutation(ExternalAccountLogin, {
        onSuccess: (data: ApiResultModel<ICheckOtpResponse>) => {
            if (data.isSuccess) {
                setJwtToken(data.data.jwt!, data.data.refreshToken);
                navigate('/');
            } else {

            }
        },
    })
    // const { externalLogin, loadingExternalLogin } = useExternalLogin();
    useEffect(() => {
        const providerTokenCache = localStorage.getItem(EXTERNAL_PROVIDE_TOKEN);
        // const substrings = ['registerloan', 'loans', 'wallet'];
        const substrings = ['/kaman'];
        if (substrings.some(sub => url.includes(sub))) {
            sessionStorage.setItem(EXTERNAL_PROVIDE, 'externalProvider')
            const params = new URLSearchParams(new URL(url).search);
            const target = params.get("target");
            const providerToken = params.get("token");
            //route from kaman
            const needsLogin = isTokenExpiredOrMissing();
            ExternalRouteMutate({ loginProvider: 'Kaman', externalToken: providerToken! });
            if (!target) {
                const newCleanUrl = `${window.location.origin}/#/`;
                window.history.replaceState(null, '', newCleanUrl);
            }
        } else {
            // const token = new URLSearchParams(window.location.search);
            // queryClient.setQueryData("URL_PARAMS", { "param": window.location.pathname, "token": token })
            // const newCleanUrl = `${window.location.origin}/#/`;
            // window.history.replaceState(null, '', newCleanUrl);
        }

    }, []);

    //external token
    const { token } = getJwtToken();
    if (isLoading) {
        return <PWASplash> </PWASplash>
    }
    if (token) {
        return (
            <div className="mainLayout">

                <MainLayout />
            </div>
        )
    }
    return (
        <UnAuthoized />
    )
}
